import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=1cd3c01f&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=1cd3c01f&prod&lang=scss"
import style2 from "./Products.vue?vue&type=style&index=2&id=1cd3c01f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3c01f",
  null
  
)

export default component.exports